﻿export const shouldMilestoneCompleteProject = (
  projectMilestones,
  milestoneId
) => {
  if (!projectMilestones) return false;

  return projectMilestones.some(
    ({ id, shouldCompleteProject }) =>
      id === milestoneId && shouldCompleteProject === true
  );
};
